import {
  useAssignmentByInspectionId,
  useMyAssignments,
} from "src/api/hooks/useAssignment";
import { lang } from "src/language/Strings";
import { useEffect, useState } from "react";
import AddAssignmentModal from "src/components/AddAssignmentModal";
import useUsers from "src/api/hooks/useUsers";
import useDeleteAssignmentMutation from "src/api/hooks/assignment/useDeleteAssignment";
import useMyUser from "src/api/hooks/useMyUser";
import { useParams } from "react-router-dom";
import useChangeTitle from "src/api/hooks/useChangeTitle";
import { useProjectVariationById } from "src/api/hooks/useProjectVariationById";

export function ShowAssignments() {
  const { inspectionId } = useParams();
  return <ShowAssignmentss id={inspectionId || ""} />;
}
function ShowAssignmentss({ id }: { id: string }) {
  const { data: assignments, invalidate } = useAssignmentByInspectionId(
    id || ""
  );
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [editAssignmentId, setEditAssignmentId] = useState<number>();
  const [deleteAssignmentId, setDeleteAssignmentId] = useState<number>();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const deleteMutation = useDeleteAssignmentMutation();
  const { data: users } = useUsers();
  const { data: inspection, isLoading } = useProjectVariationById(id);
  const { data: myUser } = useMyUser();
  useChangeTitle(lang.assignments);
  useEffect(() => {
    const modalOpener = () => {
      setIsAddModalOpen(true);
    };
    document
      .getElementById("plus-icon-add")
      ?.addEventListener("click", modalOpener);

    return () => {
      document
        .getElementById("plus-icon-add")
        ?.removeEventListener("click", modalOpener);
    };
  }, []);
  const handleDeleteAssignment = () => {
    if (deleteAssignmentId) {
      deleteMutation.mutate(String(deleteAssignmentId));
      invalidate();
      setIsDeleteModalOpen(false);
      setDeleteAssignmentId(undefined);
    }
  };

  const openDeleteModal = (assignmentId: number) => {
    setDeleteAssignmentId(assignmentId);
    setIsDeleteModalOpen(true);
  };

  return (
    <div className="mt-2">
      {assignments?.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {assignments.map((assignment) => (
            <div
              key={assignment.id}
              className="bg-white rounded-lg shadow-md p-4 border border-Grey2 hover:shadow-lg transition-shadow relative"
            >
              {myUser?.role.id % 2 === 1 && (
                <button
                  className="absolute top-2 right-2 text-red-500 hover:text-red-700 transition-colors"
                  onClick={() => openDeleteModal(assignment.id)}
                  title={lang.delete}
                >
                  <i className="fa-solid fa-times"></i>
                </button>
              )}
              <h3 className="font-semibold text-lg mb-2 pr-8">
                {assignment.title}
              </h3>
              {assignment.description && (
                <p className="text-gray-600 text-sm">
                  {assignment.description}
                </p>
              )}
              <div className="mt-4 flex justify-between items-center">
                <div className="flex flex-col gap-2">
                  {assignment.dueDate ? (
                    <span className="text-sm text-gray-500">
                      {`${lang.dueDate}: ${new Date(
                        assignment.dueDate
                      ).toLocaleDateString()}`}
                    </span>
                  ) : (
                    <span className="text-sm text-gray-500">
                      {`${lang.betweenDates}: ${new Date(
                        assignment.startTime
                      ).toLocaleDateString()} - ${new Date(
                        assignment.endTime
                      ).toLocaleDateString()} `}
                    </span>
                  )}
                  <span className="text-sm text-gray-500">{`${
                    lang.assignedTo
                  }: ${users
                    ?.filter((u) => u.id === assignment.assignedToUserId)
                    .map((u) => `${u.firstName} ${u.surname}`)
                    .join(", ")}`}</span>
                </div>
                {myUser?.role.id % 2 === 1 && (
                  <button
                    className="text-PrimaryGreen hover:text-green-600"
                    onClick={() => {
                      setIsAddModalOpen(true);
                      setEditAssignmentId(assignment.id);
                    }}
                  >
                    <i className="fa-solid fa-pen-to-square"></i>
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          {lang.noAssignments}
        </div>
      )}
      {inspection && !isLoading ? (
        <AddAssignmentModal
          isAddModalOpen={isAddModalOpen}
          setIsAddModalOpen={setIsAddModalOpen}
          editAssignmentId={editAssignmentId}
          setEditAssignmentId={setEditAssignmentId}
          inspectionId={id || ""}
          inspection={inspection}
          key={id}
        />
      ) : null}

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <div className="fixed inset-0 bg-PrimaryBlack bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-White rounded-lg p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4 text-center">
              {lang.deleteAssignment}
            </h2>
            <div className="flex gap-4 justify-center">
              <button
                onClick={() => {
                  setIsDeleteModalOpen(false);
                  setDeleteAssignmentId(undefined);
                }}
                className="px-4 py-2 bg-PrimaryGreen text-White rounded-lg hover:bg-PrimaryGreen/80 transition-colors"
              >
                {lang.cancel}
              </button>
              <button
                onClick={handleDeleteAssignment}
                className="px-4 py-2 bg-PrimaryGreen text-White rounded-lg hover:bg-PrimaryGreen/80 transition-colors"
              >
                {lang.delete}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
